export default {
  GET_SCHOOLS: 'getSchools',
  GET_SCHOOL_TYPES: 'getSchoolTypes',
  GET_MUNICIPALITIES: 'getMunicipalities',
  GET_RLVTYPES: 'getRLVClassificationTypes',
  GET_SCHOOL_INFORMATION: 'getSchoolInformation',
  GET_RESULTS: 'getResults',
  GET_PAGINATION: 'getPagination',
  GET_FILTER: 'getFilter',
};
